import React from "react";
import "../index.css";
import Button from "@mui/material/Button";
import { icons } from "../../../../../svg";

interface OriginUploadStatusProps {
  originName: string;
  onChange: () => void;
  onShowMe?: () => void;
}

const OriginAlreadyAdded: React.FC<OriginUploadStatusProps> = ({
  originName,
  onChange,
  onShowMe,
}) => {
  return (
    <div className="status-panel-container">
      <div className="selected-origin-box">
        <div>
          <span className="selected-origin-label">Selected Origin</span>
          <span className="selected-origin-value">{originName}</span>
        </div>
        <button type="button" className="change-link" onClick={onChange}>
          Change
        </button>
      </div>

      <div className="info-card">
        <div className="info-card-header">
          <div className="info-card-icon-wrapper">
            <img
              data-tooltip-id="CheckmarkCircle"
              src={icons.CheckmarkCircle}
              alt="CheckmarkCircle"
              className="icon"
            />
          </div>
          <h2 className="info-card-title">Origin Already Added!</h2>
        </div>

        <div className="info-card-body">
          <p>You can find it in:</p>
          <ul>
            <li className="bullet-blue">Other Koch Origins Section</li>
            <li className="bullet-red">Competitor Origins Section</li>
          </ul>

          <Button onClick={onShowMe}>
            <img className="show-me-button-icon" data-tooltip-id="ShowMe" src={icons.ShowMe} alt="ShowMe" />
          </Button>
        </div>

        <div className="info-card-tip">
          <div className="tip-icon-wrapper">
            <img
              data-tooltip-id="YellowLightBulb"
              src={icons.YellowLightBulb}
              alt="YellowLightBulb"
              className="icon"
            />
          </div>
          <p>
            <strong>Tip:</strong> Use the search bar in the origins list to
            quickly locate specific origins in the future.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OriginAlreadyAdded;
